/**
 * Created by TzuHsing on 2020-10-06
 */
import React, { Component } from 'react'
import ico from '../../assert/images/SportLeague.png'
import ic_launcher from '../../assert/images/ic_launcher.png'
import './index.css'

class Index extends Component {
  state = {
    link: 'https://static.sport147.cn/pc/installer.exe',
    scoreBoardAppLink: 'https://static.sport147.cn/scoreBoard/app-release-1_1_1-5.apk'
  }
  render() {
    return (
      <div className='toolList-container'>
        <a href={this.state.link}>
          <div className='toolList-item'>
            <img src={ico} alt="收银端工具下载" />
            <div className='toolList-item-title'>收银端安装包下载</div>
          </div>
        </a>
        <a href={this.state.scoreBoardAppLink}>
          <div className='toolList-item'>
            <img src={ic_launcher} alt="台风体育智能记分系统" />
            <div className='toolList-item-title'>台风体育智能记分系统</div>
          </div>
        </a>
      </div>
    )
  }
}

export default Index


// WEBPACK FOOTER //
// ./src/containers/ToolList/index.js